// extracted by mini-css-extract-plugin
export default {"imgIcon":"ServiceProviderTemplate_imgIcon__Wvb6S"};